<template>
  <main-content with_go_back_bar>
    <kt-panel class="p-3">
      <div
        class="container p-3 pt-5 my-4 border in-border-header"
        style="padding-top: 1.5rem !important"
      >
        <kt-form-section is-first>
          <div class="section-header">تنظیمات کارمزد نماینده {{ `( ${user} )` }}</div>
          <div class="row">
            <div class="col-md-12">
              <form @submit.prevent class="kt-form" id="marketer_wage">
                <kt-row
                  v-for="wage in wages"
                  :key="wage.id"
                  lg="12"
                  md="12"
                  xs="12"
                  class="align-items-center p-3 p-sm-0 mt-4 mt-sm-0 rowMe"
                >
                  <input
                    type="text"
                    disabled
                    :value="wage.period_number"
                    class="text-center border-0 bg-white d-none d-sm-block"
                    style="width: 25px"
                  />
                  <kt-col class="col-12 col-sm-4">
                    <kt-form-section>
                      <kt-form-group>
                        <kt-form-label for="period-duration-days">
                          {{ $t("marketing.marketing_wage.period_duration") }}
                        </kt-form-label>
                        <kt-form-control
                          type="number"
                          name="period-duration-days"
                          id="period-duration-days"
                          v-model="wage.from"
                        >
                        </kt-form-control>
                      </kt-form-group>
                    </kt-form-section>
                  </kt-col>
                  <kt-col class="col-12 col-sm-4">
                    <kt-form-section>
                      <kt-form-group>
                        <kt-form-label for="wage">
                          {{ $t("marketing.marketing_wage.wage") }}
                        </kt-form-label>
                        <kt-form-control
                          type="text"
                          placeholder=""
                          name="wage"
                          id="wage"
                          max="100"
                          v-model="wage.wage"
                        >
                        </kt-form-control>
                      </kt-form-group>
                    </kt-form-section>
                  </kt-col>
                  <input
                    style="width: 15px; height: 15px"
                    :checked="wage.to"
                    :ref="`to${wage.id}`"
                    type="radio"
                    name="to"
                    :title="$t('marketing.marketing_wage.infininte')"
                  />
                  <div class="d-flex flex-nowrap">
                    <button
                      @click="deleteItem(wage)"
                      title="حذف"
                      type="button"
                      class="btn btn-label-danger trash-btn ml-3"
                    >
                      <i class="la la-trash-o"></i>
                    </button>
                    <button
                      :id="`update-wage${wage.id}`"
                      type="button"
                      @click="updateItem(wage)"
                      style="cursor: pointer"
                      class="btn btn-info ml-2"
                      v-text="$t('marketing.marketing_wage.update')"
                    ></button>
                  </div>
                </kt-row>
                <hr class="my-5" v-if="newWages.length > 0 && wages.length > 0" />
                <div v-if="newWages.length > 0">
                  <kt-row
                    v-for="wage in newWages"
                    :key="wage.id"
                    lg="12"
                    md="12"
                    xs="12"
                    class="align-items-center p-3 p-sm-0 mt-4 mt-sm-0 rowMe"
                  >
                    <input
                      type="text"
                      disabled
                      :value="wage.period_number"
                      class="text-center border-0 bg-white"
                      style="width: 25px"
                    />
                    <kt-col class="col-12 col-sm-2">
                      <kt-form-section>
                        <kt-form-group>
                          <kt-form-label for="period-duration-days">
                            از تعداد تراکنش
                          </kt-form-label>
                          <kt-form-control
                            type="number"
                            name="period-duration-days"
                            id="period-duration-days"
                            v-model="wage.from"
                          >
                          </kt-form-control>
                        </kt-form-group>
                      </kt-form-section>
                    </kt-col>
                    <kt-col class="col-12 col-sm-2">
                      <kt-form-section>
                        <kt-form-group>
                          <kt-form-label for="period-duration-days">
                            تا تعداد تراکنش
                          </kt-form-label>
                          <kt-form-control
                            type="number"
                            name="period-duration-days"
                            id="period-duration-days"
                            v-model="wage.to"
                          >
                          </kt-form-control>
                        </kt-form-group>
                      </kt-form-section>
                    </kt-col>
                    <kt-col class="col-12 col-sm-3">
                      <kt-form-section>
                        <kt-form-group>
                          <kt-form-label for="wage"> درصد کارمزد پرداختی</kt-form-label>
                          <kt-form-control
                            type="text"
                            placeholder=""
                            name="wage"
                            id="wage"
                            max="100"
                            v-model="wage.wage_percent"
                          >
                          </kt-form-control>
                        </kt-form-group>
                      </kt-form-section>
                    </kt-col>
                    <kt-col class="col-12 col-sm-2">
                      <kt-form-section>
                        <kt-form-group>
                          <kt-form-label for="wage"> مبلغ پایه کارمزد (ریال) </kt-form-label>
                          <kt-form-control
                            type="text"
                            placeholder=""
                            name="wage"
                            id="wage"
                            v-model="wage.total_wage_amount"
                          >
                          </kt-form-control>
                        </kt-form-group>
                      </kt-form-section>
                    </kt-col>


                    <div class="d-flex flex-nowrap">
                      <button
                        @click="deleteNewItem(wage)"
                        title="حذف"
                        type="button"
                        class="btn btn-label-danger trash-btn ml-3"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <button
                        v-if="!wage.id"
                        @click="registerNewItem(wage)"
                        type="button"
                        style="cursor: pointer"
                        class="btn btn-info ml-2"
                        :id="`register-new-wage${wage.id}`"
                        v-text="$t('marketing.marketing_wage.register')"
                      ></button>
                      <button
                        v-else
                        @click="registerNewItem(wage)"
                        type="button"
                        style="cursor: pointer"
                        class="btn btn-success ml-2"
                        :id="`update-new-wage${wage.id}`"
                      >
                        بروزرسانی
                      </button>
                    </div>
                  </kt-row>
                </div>
                <div v-else>
                  <p class="text-center my-2">
                    برای ایجاد کارمزد کاربر روی دکمه پایین کلیک کنید
                  </p>
                </div>
                <kt-row>
                  <div class="w-100 d-flex align-items-center justify-content-center">
                    <button
                      type="button"
                      @click="addWage()"
                      class="btn btn-outline-success mt-3 ml-3"
                    >
                      ایجاد کارمزد کاربر
                    </button>
                  </div>
                </kt-row>
              </form>
            </div>
          </div>
        </kt-form-section>
      </div>
    </kt-panel>
  </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import toastr from "toastr";
import Axios from "axios";
import { KTApp } from "@/plugins/core/app";
import $ from "jquery";
export default {
  name: "posAgentSetting",
  components: {
    "main-content": mainContent,
  },
  data() {
    return {
      create_psp: true,
      wages: [],
      newWages: [],
      user: ''
    };
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };

      return toastr;
    },
  },
  methods: {
    showPsp() {
      this.create_psp = true;
    },
    addWage() {
      const wage = {
        wage_percent: "",
        from: 0,
        to: 0,
        total_wage_amount: "",
      };
      this.newWages.push(wage);
    },
    deleteNewItem(wage) {
      if (wage.id) {
        Axios.delete(`marketing/pos-visitor/pos_wage_marketing_setting/${wage.id}`)
          .then((response) => {
            this.toastr.success(response.data.message, {
              positionClass: "toast-top-center",
            });
            this.getPosWage();
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message);
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          });
      } else {
        const i = this.newWages.indexOf(wage);
        this.newWages.splice(i, 1);
      }
    },
    getPosWage() {
      Axios.get(
        `marketing/pos-visitor/pos_wage_marketing_setting/${this.$route.params.id}`
      ).then((response) => {
        this.newWages = response.data.data;
        this.user = response.data.data[0].user.full_name ? response.data.data[0].user.full_name : ''
      });
    },
    registerNewItem(wage) {
      let btnUpdate = $(`#update-new-wage${wage.id}`);
      let btnRegister = $(`#register-new-wage${wage.id}`);

      if (!wage.id) {
        KTApp.progress(btnRegister);
        Axios.post(`marketing/pos-visitor/pos_wage_marketing_setting`, {
          user_id: this.$route.params.id,
          from: Number(wage.from),
          to: Number(wage.to),
          wage_percent: wage.wage_percent,
          total_wage_amount: Number(wage.total_wage_amount),
        })
          .then((response) => {
            KTApp.unprogress(btnRegister);
            this.toastr.success(response.data.message);
            this.getPosWage();
          })
          .catch(({ response }) => {
            KTApp.unprogress(btnRegister);
            this.toastr.error(response.data.message);
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          });
      } else {
        KTApp.progress(btnUpdate);
        Axios.put(
          `marketing/pos-visitor/pos_wage_marketing_setting/${wage.id}`,
          {
            user_id: this.$route.params.id,
            from: Number(wage.from),
            to: Number(wage.to),
            wage_percent: wage.wage_percent,
            total_wage_amount: Number(wage.total_wage_amount),
          }
        )
          .then((response) => {
            KTApp.unprogress(btnUpdate);
            this.toastr.success(response.data.message);
            this.getPosWage();
          })
          .catch(({response}) => {
            KTApp.unprogress(btnUpdate);
            this.toastr.error(response.data.message);
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          }).finally(() => {
            KTApp.unprogress(btnUpdate);
          });
      }
    },
  },
  mounted() {
    this.getPosWage();
  },
};
</script>

<style scoped></style>
